import { render, staticRenderFns } from "./MCBindUserDialog.vue?vue&type=template&id=4843f4ac&scoped=true&lang=pug&"
import script from "./MCBindUserDialog.vue?vue&type=script&lang=ts&"
export * from "./MCBindUserDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MCBindUserDialog.vue?vue&type=style&index=0&id=4843f4ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4843f4ac",
  null
  
)

export default component.exports